import React, { useMemo, useState } from 'react';
import { LuChevronDown, LuSearch, LuX } from 'react-icons/lu';
import ModalShell from '../ui/ModalShell';

// Filtro de cliente del Mapa (2-nov-2026): antes era un desplegable del navegador (se veía distinto al resto de
// la app y no tenía buscador). Ahora: Todos · Empresas · Particulares, y "Una empresa" abre una lista con buscador.
// filtro: 'todos' | 'EMPRESA' | 'PARTICULAR' | `c-<id>` · empresas: [[id, { nombre }], ...]
export default function FiltroClienteMapa({ filtro, empresas, onCambiar }) {
    const [abierto, setAbierto] = useState(false);
    const [q, setQ] = useState('');
    const elegida = filtro.startsWith('c-') ? empresas.find(([id]) => `c-${id}` === filtro)?.[1]?.nombre : null;
    const lista = useMemo(() => {
        const t = q.trim().toLowerCase();
        return t ? empresas.filter(([, c]) => c.nombre.toLowerCase().includes(t)) : empresas;
    }, [empresas, q]);
    const chip = (on) => `h-9 px-3 shrink-0 rounded-xl text-label font-black inline-flex items-center gap-1.5 border-2 ${on ? 'border-brand-red bg-[rgba(232,66,47,0.10)] text-ink' : 'border-transparent bg-chip text-secondary'}`;
    return (
        <>
            {[['todos', 'Todos'], ['EMPRESA', 'Empresas'], ['PARTICULAR', 'Particulares']].map(([id, label]) => (
                <button key={id} type="button" onClick={() => onCambiar(id)} aria-pressed={filtro === id} className={chip(filtro === id)}>{label}</button>
            ))}
            {elegida ? (
                <span className={`${chip(true)} max-w-[60%]`}>
                    <button type="button" onClick={() => setAbierto(true)} className="truncate">{elegida}</button>
                    <button type="button" onClick={() => onCambiar('todos')} aria-label="Sacar filtro"><LuX size={14} /></button>
                </span>
            ) : empresas.length > 0 && (
                <button type="button" onClick={() => setAbierto(true)} className={chip(false)}>Una empresa <LuChevronDown size={14} /></button>
            )}
            {abierto && (
                <ModalShell titulo="Ver una empresa" subtitulo={`${empresas.length} empresa${empresas.length !== 1 ? 's' : ''}`} onCerrar={() => { setAbierto(false); setQ(''); }}>
                    <div className="space-y-2">
                        <div className="h-11 px-3 rounded-xl bg-chip flex items-center gap-2">
                            <LuSearch size={16} className="text-muted" />
                            <input autoFocus value={q} onChange={e => setQ(e.target.value)} placeholder="Buscar empresa…"
                                className="flex-1 bg-transparent outline-none text-body text-ink placeholder:text-muted" />
                        </div>
                        <div className="divide-y divide-black/[0.06] dark:divide-white/[0.06]">
                            {lista.map(([id, c]) => (
                                <button key={id} type="button" onClick={() => { onCambiar(`c-${id}`); setAbierto(false); setQ(''); }}
                                    className={`w-full text-left py-3 px-1 text-body font-bold ${filtro === `c-${id}` ? 'text-brand-red' : 'text-ink'}`}>
                                    {c.nombre}
                                </button>
                            ))}
                            {lista.length === 0 && <p className="py-6 text-center text-caption text-muted">No hay ninguna con ese nombre</p>}
                        </div>
                    </div>
                </ModalShell>
            )}
        </>
    );
}
